export default {
  NEW_EMAIL: 'Novo e-mail',
  NO_CONTACTS_ADDED: 'Nenhum contato adicionado',
  UPLOAD_ERROR: 'Não foi possível fazer upload.',
  SEND_ERROR: 'Não foi possível enviar e-mail',
  SEARCH_CONTACT_ERROR: 'Erro ao buscar contatos: {error}',
  MORE: 'Mais',
  FILTER: 'Filtrar',
  FILE: 'Arquivo',
  SPAM: 'Spam',
  NOT_SPAM: 'Não é spam',
  DELETE: 'Apagar',
  MARK_AS_READ: 'Marcar como lida',
  MARK_AS_UNREAD: 'Marcar como não lida',
  SEARCH: 'Buscar',
  FOR: 'Para',
  SEARCH_EMAIL: 'Buscar e-mail',
  TO_FILE: 'Arquivar',
  UNARCHIVE: 'Desarquivar',
  PERMANENTLY_DELETE: 'Excluir definitivamente',
  TO_RECOVER: 'Recuperar',
  EMAIL_DOES_NOT_EXIST: 'E-mail não existe',
};
